import { gql } from "../generated-graphql";

/**
 * Shared by useCheckForFile and useLongPollingForFile — codegen requires
 * operations sharing a name to be the same document, so there is exactly one
 * copy of it.
 *
 * `filename` names the download via the signed URL's Content-Disposition —
 * the only place a name can take effect, since browsers ignore the anchor
 * `download` attribute on cross-origin (S3) URLs. Omit it to fall back to
 * the S3 key's basename.
 */
const CHECK_FOR_FILE = gql(`query CheckForFile($key: String!, $filename: String) {
    checkForFile(key: $key, filename: $filename) {
      exists
      signedUrl
    }
  }`);

export default CHECK_FOR_FILE;
